import { ModalFullscreen } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Gallery.css';

interface IGalleryProps {
  imageUrl: string;
  imageAlt: string;
  onClose(): void;
}

export const Gallery: React.FC<React.PropsWithChildren<IGalleryProps>> = ({ imageUrl, imageAlt, onClose }) => {
  return (
    <ModalFullscreen open onClose={onClose} theme="black">
      <div className={styles['container']}>
        <button className={styles['close']} aria-label="Закрыть галерею" onClick={onClose}>
          <IconActionClose16 color="icon-inverted-default" />
        </button>
        <img className={styles['image']} src={imageUrl} alt={imageAlt} />
      </div>
    </ModalFullscreen>
  );
};

Gallery.displayName = 'Gallery';
